import { AGGREGATE_NAMES, type LOAN_REQUEST_OFFER_SOURCE, LOAN_REQUEST_RESOLVERS } from 'cpool-constants';
import { schemaLoanRequestResolver_GetOffersAcceptanceStatusByLoanRequestId } from 'cpool-tables/backend-resolvers';

import { useAggregateQuery } from '~/queryUtils/useQuery';

type Props = {
    loanRequestId: string;
    source: LOAN_REQUEST_OFFER_SOURCE;
};

export const useOffersAcceptanceStatusByLoanRequestId = ({ loanRequestId, source }: Props) => {
    return useAggregateQuery({
        acl: { loanRequestId },
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        resolverName: LOAN_REQUEST_RESOLVERS.getOffersAcceptanceStatusByLoanRequestId,
        schema: schemaLoanRequestResolver_GetOffersAcceptanceStatusByLoanRequestId,
        searchParams: { id: loanRequestId, source },
    });
};
